(function(angular){
	'use strict';
	
	angular.module('starterPortfolioModule', [
		'coreModule',
		'campaignCtaModule',
		'localStorageModule',
		'orderFormModule',
		'scrollDownPromptModule',
		'topQuestionsModule',
		'yieldComparisonChartModule'
	]).value('globalConfig', globalConfig);

})(window.angular);